export function sendSMSMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      sendSMSId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateSendSMSId(json) {
  return {
    data: {...json, id: json.objectId},
  };
}
export function fixGetManySendSMSs(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateSendSMSId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function sendSMSMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, sendSMSId: json.result.objectId},
  };
}